export const TRACK_VERSIONS = [
    {
        code: 'remix',
        name: 'tracks.versions.remix'
    }, {
        code: 'live',
        name: 'tracks.versions.live'
    }, {
        code: 'acoustic',
        name: 'tracks.versions.acoustic'
    }, {
        code: 'demo',
        name: 'tracks.versions.demo'
    }, {
        code: 'extended',
        name: 'tracks.versions.extended'
    }, {
        code: 'remastered',
        name: 'tracks.versions.remastered'
    }, {
        code: 'soundtrack',
        name: 'tracks.versions.soundtrack'
    }, {
        code: 'club_mix',
        name: 'tracks.versions.club_mix'
    }
]

export const TRACK_CONTRIBUTOR_ROLES = [
    {
        code: 'PRIMARY',
        name: 'tracks.contributors.roles.primary'
    }, {
        code: 'FEATURED',
        name: 'tracks.contributors.roles.features'
    }, {
        code: 'PRODUCER',
        name: 'tracks.contributors.roles.producer'
    }, {
        code: 'REMIXER',
        name: 'tracks.contributors.roles.remixer'
    }, {
        code: 'COMPOSER',
        name: 'tracks.contributors.roles.composer'
    }, {
        code: 'MIXER',
        name: 'tracks.contributors.roles.mixer'
    }, {
        code: 'MASTERING_ENGINEER',
        name: 'tracks.contributors.roles.mastering-engineer'
    }, {
        code: 'LYRICIST',
        name: 'tracks.contributors.roles.lyricist'
    }
].sort((a, b) => a.code > b.code ? 1 : -1)
